import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-restore-anonymized-dialog',
  templateUrl: './restore-anonymized-dialog.component.html',
  styleUrls: ['./restore-anonymized-dialog.component.css']
})
export class RestoreAnonymizedDialogComponent implements OnInit {

  public title = 'Restore anonymized customer';
  public text = 'Please provide the private key in PEM format to decrypt the customer\'s personal data';

  public privateKeyPem = '';

  constructor(
    public dialogRef: MatDialogRef<RestoreAnonymizedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

  }

  onYesClick(): void {

    this.dialogRef.close(this.privateKeyPem);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

